import React, { useState, useEffect, useContext } from 'react'
import {
    Form,
    Button,
    Row,
    Col,
    Input,
    Card,
    CardBody,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label
} from "reactstrap"

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Select from "react-select"
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'

const FormPage = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [unidades, setUnidades] = useState([])
    const [claves, setClaves] = useState([])

    const ObjetoImpCatalogo = [{
        value: '01',
        label: '(01) Excento de impuestos'
    }, {
        value: '02',
        label: '(02) Objeto de impuesto'
    }, {
        value: '03',
        label: '(03) Objeto del impuesto y no obligado al desglose'
    }]

    const [id, setId] = useState()
    const [noIdentificacion, setNoIdentificacion] = useState('')
    const [claveProdServ, setClaveProdServ] = useState('')
    const [claveUnidad, setClaveUnidad] = useState('')
    const [valorUnitario, setValorUnitario] = useState('')
    const [descripcion, setDescripcion] = useState('')
    const [ObjetoImp, setObjetoImp] = useState({
        value: '02',
        label: '(02) Objeto de impuesto'
    })

    useEffect(() => {
        (async () => {
            await fetchUnidades()
            await fetchClaves()
        })()
    }, [])

    useEffect(() => {
        if (props.data === undefined) { return }
        const { data } = props

        setId(data._id)
        setNoIdentificacion(data.noIdentificacion)
        setValorUnitario(data.valorUnitario)
        setDescripcion(data.descripcion)

        const oi = ObjetoImpCatalogo.find(item => item.value === data.ObjetoImp)
        if (oi) { setObjetoImp(oi) }
        // claveProdServ and claveUnidad intentionally not set here —
        // they depend on claves/unidades being loaded first
    }, [props.data])

    useEffect(() => {
        if (claves.length > 0 && props.data?.claveProdServ) {
            const clave = claves.find(item => item.value === props.data.claveProdServ)
            if (clave) { setClaveProdServ(clave) }
        }
    }, [claves, props.data])

    useEffect(() => {
        if (unidades.length > 0 && props.data?.claveUnidad) {
            const unidad = unidades.find(item => item.value === props.data.claveUnidad)
            if (unidad) { setClaveUnidad(unidad) }
        }
    }, [unidades, props.data])

    const fetchUnidades = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getUnidades()
            let data = []
            response.data.data.map((item) => {
                return data.push({
                    value: item.clave,
                    label: `(${item.clave}) ${item.descripcion}`
                })
            })

            setUnidades(data)
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const fetchClaves = async () => {
        setLoading(true)

        try {
            const response = await ApiService.getClaves()
            let data = []
            response.data.data.map((item) => {
                return data.push({
                    value: item.clave,
                    label: `(${item.clave}) ${item.descripcion}`
                })
            })

            setClaves(data)
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!_validateForm()) {
            toastr.error('No olvides llenar los campos.', 'Error')

            return
        }

        setLoading(true)

        let data = {
            noIdentificacion,
            claveProdServ: claveProdServ.value,
            claveUnidad: claveUnidad.value,
            valorUnitario,
            descripcion,
            ObjetoImp: ObjetoImp.value
        }

        if (props.data !== undefined) {
            data = {
                ...data,
                id
            }

            await _updateService(data)
            props.history.push('/servicios')

            return false
        }

        await _createService(data)

        props.history.push('/servicios')
    }

    const _createService = async (data) => {
        setLoading(true)

        try {
            const response = await ApiService.createService(data)

            if (!response.data.success) {
                toastr.error(`No pude agregar el servicio`, 'Error')

                return false
            }

            window.analytics.track('Servicio Agregado')
            toastr.success(response.data.message, '¡Éxito!')
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const _updateService = async (data) => {
        setLoading(true)

        try {
            const response = await ApiService.updateService(id, data)

            if (!response.data.success) {
                toastr.error(response.data.message, 'Error')

                return false
            }

            window.analytics.track('Servicio Actualizado')
            toastr.success(response.data.message, '¡Éxito!')
        } catch (error) {
            toastr.error(`No pude conectarme con el servidor`, 'Problema de conexión')
        } finally {
            setLoading(false)
        }
    }

    const _validateForm = () => {
        if (descripcion === '') { return false }
        if (claveUnidad === '') { return false }
        if (claveProdServ === '') { return false }
        if (valorUnitario === '') { return false }
        if (noIdentificacion === '') { return false }

        return true
    }

    return (
        <React.Fragment>
            <Form id="create" data-testid="service-form" method="POST" onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12}>
                        <Card style={{ textAlign: 'right' }}>
                            <CardBody>
                                <Button
                                    onClick={() => { window.history.go(-1) }}
                                    className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    <i className={`mdi mdi-check`}></i> Guardar
                                </Button>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label htmlFor="claveProdServ">
                                                Clave del SAT
                                            </Label>

                                            <Select
                                                data-testid="service-sat-code"
                                                id="claveProdServ"
                                                value={claveProdServ}
                                                placeholder={`Escribe para buscar`}
                                                onChange={(target) => {
                                                    setClaveProdServ(target)
                                                }}
                                                options={claves}
                                                classNamePrefix="select2-selection"
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label htmlFor="claveUnidad">
                                                Unidad
                                            </Label>

                                            <Select
                                                data-testid="service-unit"
                                                id="claveUnidad"
                                                value={claveUnidad}
                                                placeholder={`Escribe para buscar`}
                                                onChange={(target) => {
                                                    setClaveUnidad(target)
                                                }}
                                                options={unidades}
                                                classNamePrefix="select2-selection"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>
                                                No. Identificación
                                            </Label>
                                            <Input
                                                data-testid="service-sku"
                                                type="text"
                                                className="form-control"
                                                value={noIdentificacion}
                                                onChange={event => setNoIdentificacion(event.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Valor Unitario</Label>

                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>$</InputGroupText>
                                                </InputGroupAddon>

                                                <Input id="valorUnitario"
                                                    data-testid="service-price"
                                                    type="number"
                                                    value={valorUnitario}
                                                    onChange={(e) => {
                                                        setValorUnitario(e.target.value)
                                                    }} />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Objeto de Impuesto</Label>

                                            <Select
                                                defaultValue={ObjetoImp}
                                                value={ObjetoImp}
                                                onChange={(value) => {
                                                    setObjetoImp(value)
                                                }}
                                                placeholder={`Seleccionar opción`}
                                                options={ObjetoImpCatalogo}
                                                classNamePrefix="select2-selection"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Label>
                                                Descripción
                                            </Label>
                                            <textarea
                                                data-testid="service-description"
                                                type="text"
                                                className="form-control"
                                                value={descripcion}
                                                rows={4}
                                                onChange={event => setDescripcion(event.target.value)}>
                                            </textarea>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Form>
        </React.Fragment>
    )
}

export default FormPage
